import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/base/base.service';
import { Constants } from 'src/app/app.constants';
import { LookupSource, LS } from 'src/app/shared/base/base.models';

@Injectable({
  providedIn: 'root'
})
export class PointsOfSaleService extends BaseService {

  public getPointsOfSaleOptions() {
    return this.getOptionsByMultipleFieldsFilter(`${Constants.contextPath}/point-of-sales`, 'name', ['code', 'name'], (response) => {
      if(Array.isArray(response))
          for(let p of response)
            p.name = `${p.code} - ${p.name}`;
        else 
          response.name = `${response.code} - ${response.name}`;
        return response;
      }
    ); 
  }

  public getPointsOfSaleLookup(){
    return this.getLookup(LS.get('N'), LS.get('N'), LookupSource.POINT_OF_SALE);
  }
}
